"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const imageInputStyles_1 = __importDefault(require("../imageInputStyles"));
const theme_1 = __importDefault(require("../../../styles/theme"));
const icon_1 = __importStar(require("../../icon/icon"));
const text_1 = __importStar(require("../../text/text"));
const touchableElement_1 = __importDefault(require("../../pressables/touchableElement"));
const input_1 = require("../../input/input");
const styles_1 = __importDefault(require("../../../styles/styles"));
const textStyles_1 = __importDefault(require("../../text/textStyles"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const ImageInput = ({ toUploadTitle, setImage, setImageName, image, error = '', typeAvatar = false, }) => {
    const avatarFileInputRef = react_1.default.createRef();
    const fileInputRef = react_1.default.createRef();
    const showError = !!error;
    const chooseFileHandler = async (ie) => {
        const file = ie.target.files[0];
        const fileURL = URL.createObjectURL(file);
        setImage(fileURL);
        if (setImageName !== undefined) {
            setImageName(file.name);
        }
    };
    const avatarInputFileComponent = react_1.default.createElement("input", { ref: avatarFileInputRef, type: "file", onChange: chooseFileHandler, hidden: true });
    const inputFileComponent = react_1.default.createElement("input", { ref: fileInputRef, type: "file", onChange: chooseFileHandler, hidden: true });
    const pressHandler = () => {
        if (typeAvatar) {
            avatarFileInputRef.current.click();
        }
        else {
            fileInputRef.current.click();
        }
    };
    const hasImage = Object.keys(image).length > 0;
    let content = (react_1.default.createElement(touchableElement_1.default, { onPress: pressHandler, eventName: "add_image_input" },
        react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", error: showError, theme: input_1.themePaper, autoCapitalize: "none", editable: false, render: () => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow, { paddingHorizontal: 5 }] },
                inputFileComponent,
                react_1.default.createElement(react_native_1.View, { style: imageInputStyles_1.default.text },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY }, hasImage ? 'FileUploaded.jpeg' : toUploadTitle)),
                react_1.default.createElement(react_native_1.View, { style: hasImage ? imageInputStyles_1.default.selectedContainer : imageInputStyles_1.default.iconContainer },
                    react_1.default.createElement(icon_1.default, { name: hasImage ? icon_1.CHECK_VECTOR : icon_1.CLIP_VECTOR })))) })));
    if (typeAvatar) {
        content = (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexOne] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: textStyles_1.default.bold }, toUploadTitle),
                react_1.default.createElement(touchableElement_1.default, { onPress: pressHandler, eventName: "add_image_input" },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        avatarInputFileComponent,
                        hasImage ? (react_1.default.createElement(react_native_paper_1.Avatar.Image, { style: imageInputStyles_1.default.thumbnail, source: { uri: typeof image === 'string' ? image : '' } })) : (react_1.default.createElement(icon_1.default, { name: icon_1.UPLOAD_AVATAR })))))));
    }
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
        content,
        showError && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: typeAvatar ? [styles_1.default.centerChildHorizontalVertical] : [] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_ERROR, color: colors_1.default.COLOR_CRITICAL }, error))))));
};
exports.default = ImageInput;
